import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { ComponentsModule } from '../components/components.module';
import { MatDialogModule } from '@angular/material/dialog';
import { DetailOrderDialogComponent } from './detail-order-dialog/detail-order-dialog.component';
import { SignatureDialogComponent } from './signature-dialog/signature-dialog.component';
import { SignaturePadModule } from 'angular2-signaturepad';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { NewSpecialtyComponent } from './new-specialty/new-specialty.component';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { RequestPiecesDialogComponent } from './request-pieces-dialog/request-pieces-dialog.component';
import { PreviewReceiptComponent } from './preview-receipt/preview-receipt.component';
import { PipesModule } from '../pipes/pipes.module';
import { DoctorInformationDialogComponent } from './doctor-information-dialog/doctor-information-dialog.component';
import { ChangePayMethodComponent } from './change-pay-method/change-pay-method.component';
import { SuccessPayComponent } from './success-pay/success-pay.component';
import { RouterModule } from '@angular/router';
import { AddPaymentMethodComponent } from './add-payment-method/add-payment-method.component';
import { NgxMaskModule } from 'ngx-mask';
import { AddTaxDataComponent } from './add-tax-data/add-tax-data.component';
import { AddDirectionComponent } from './add-direction/add-direction.component';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { AddClinicInformationComponent } from './add-clinic-information/add-clinic-information.component';
import { ContainerSelectorComponent } from './container-selector/container-selector.component';
import { ImageViewerComponent } from './image-viewer/image-viewer.component';
import { UtilitiesCalculatorComponent } from './utilities-calculator/utilities-calculator.component';
import { SalesProductsComponent } from './sales-products/sales-products.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { PendingProductsComponent } from './pending-products/pending-products.component';
import { PackagesSentComponent } from './packages-sent/packages-sent.component';
import { ServiceQualifierComponent } from './service-qualifier/service-qualifier.component';
import { NgxStarRatingModule } from 'ngx-star-rating';
import { NotificationErrorInLabelsComponent } from './notification-error-in-labels/notification-error-in-labels.component';
import { MatRadioModule } from '@angular/material/radio';
import { NotificationAuthorizeOrderComponent } from './notification-authorize-order/notification-authorize-order.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { NeedPrescriptionComponent } from './need-prescription/need-prescription.component';
import { InvoiceDetailComponent } from './invoice-detail/invoice-detail.component';
import { NotAvailableItemComponent } from './not-available-item/not-available-item.component';
import { SucessChangePaymentCardComponent } from './sucess-change-payment-card/sucess-change-payment-card.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { DirectivesModule } from '../directives/directives.module';
import { ConektaComponent } from './conekta/conekta.component';
import { OverdueInvoicesComponent } from './overdue-invoices/overdue-invoices.component';
import { InsufficientCreditComponent } from './insufficient-credit/insufficient-credit.component';
import { DetailProductsComponent } from './detail-products/detail-products.component';
import { NotificationSavedProductsComponent } from './notification-saved-products/notification-saved-products.component';
import { SapFiltersComponent } from './sap-filters/sap-filters.component';
import { DisplayVideoComponent } from './display-video/display-video.component';
import { QuotationProductDialogComponent } from './quotation-product-dialog/quotation-product-dialog.component';
import { NotificationMissingProductComponent } from './notification-missing-product/notification-missing-product.component';
import { QuotationCommentsComponent } from './quotation-comments/quotation-comments.component';
import { ChangePageComponent } from './change-page/change-page.component';
import { HoffmanConfirmDialogComponent } from './hoffman-confirm-dialog/hoffman-confirm-dialog.component';
import { BuyRemainingPiecesComponent } from './buy-remaining-pieces/buy-remaining-pieces.component';
import { SapDetailsComponent } from './sap-details/sap-details.component';
import { IncompleteDirectionComponent } from './incomplete-direction/incomplete-direction.component';
import { ProductsWithNamePrintedComponent } from './products-with-name-printed/products-with-name-printed.component';
import { ConfirmRecipeComponent } from './confirm-recipe/confirm-recipe.component';
import { ConfirmDirectionComponent } from './confirm-direction/confirm-direction.component';
import { PaypalComponent } from './paypal/paypal.component';
import { ConfirmPurchaseComponent } from './confirm-purchase/confirm-purchase.component';
import { ConfirmInvalidFavorBalanceComponent } from './confirm-invalid-favor-balance/confirm-invalid-favor-balance.component';
import { BBVAOpenPageComponent } from './bbvaopen-page/bbvaopen-page.component';
import { OpenTransactionsBBVAComponent } from './open-transactions-bbva/open-transactions-bbva.component';
import { EmailPreviewComponent } from './email-preview/email-preview.component';
import { NewBeneficiariesComponent } from './new-beneficiaries/new-beneficiaries.component';
import { InvalidPromotionalCodeComponent } from './invalid-promotional-code/invalid-promotional-code.component';
import { InvalidItemsComponent } from './invalid-items/invalid-items.component';
import { BbvaCardsComponent } from './bbva-cards/bbva-cards.component';
import { DeliveryCommentsComponent } from './delivery-comments/delivery-comments.component';
import { ConfirmDeleteCardComponent } from './confirm-delete-card/confirm-delete-card.component';
import { MaxMinPiecesComponent } from './max-min-pieces/max-min-pieces.component';
import { AdvisorClientCreditComponent } from './advisor-client-credit/advisor-client-credit.component';
import { PaymentTimeComponent } from './payment-time/payment-time.component';
import { NewResponsibleDoctorComponent } from './new-responsible-doctor/new-responsible-doctor.component';
import { AcceptNewPricesComponent } from './accept-new-prices/accept-new-prices.component';
import { WarningPromotionalCodeComponent } from './warning-promotional-code/warning-promotional-code.component';
import { WProductsNoValidPromoCodeComponent } from './w-products-no-valid-promo-code/w-products-no-valid-promo-code.component';
import { ContinueBackMessageComponent } from './continue-back-message/continue-back-message.component';
import { ConfirmDoctorNameDialogComponent } from './confirm-doctor-name-dialog/confirm-doctor-name-dialog.component';
import { ChangeInvoiceTypeDialogComponent } from './change-invoice-type-dialog/change-invoice-type-dialog.component';
@NgModule({
  declarations: [
    DetailOrderDialogComponent,
    SignatureDialogComponent,
    NewSpecialtyComponent,
    RequestPiecesDialogComponent,
    PreviewReceiptComponent,
    DoctorInformationDialogComponent,
    ChangePayMethodComponent,
    SuccessPayComponent,
    AddPaymentMethodComponent,
    AddDirectionComponent,
    AddTaxDataComponent,
    AddClinicInformationComponent,
    ContainerSelectorComponent,
    ImageViewerComponent,
    UtilitiesCalculatorComponent,
    SalesProductsComponent,
    PendingProductsComponent,
    PackagesSentComponent,
    NotificationErrorInLabelsComponent,
    ServiceQualifierComponent,
    NotificationAuthorizeOrderComponent,
    NeedPrescriptionComponent,
    InvoiceDetailComponent,
    NotAvailableItemComponent,
    SucessChangePaymentCardComponent,
    ConektaComponent,
    InsufficientCreditComponent,
    OverdueInvoicesComponent,
    DetailProductsComponent,
    NotificationSavedProductsComponent,
    SapFiltersComponent,
    DisplayVideoComponent,
    QuotationProductDialogComponent,
    NotificationMissingProductComponent,
    QuotationCommentsComponent,
    ChangePageComponent,
    HoffmanConfirmDialogComponent,
    BuyRemainingPiecesComponent,
    SapDetailsComponent,
    IncompleteDirectionComponent,
    ProductsWithNamePrintedComponent,
    ConfirmRecipeComponent,
    ConfirmDirectionComponent,
    PaypalComponent,
    ConfirmPurchaseComponent,
    ConfirmInvalidFavorBalanceComponent,
    BBVAOpenPageComponent,
    OpenTransactionsBBVAComponent,
    EmailPreviewComponent,
    NewBeneficiariesComponent,
    InvalidPromotionalCodeComponent,
    InvalidItemsComponent,
    BbvaCardsComponent,
    DeliveryCommentsComponent,
    ConfirmDeleteCardComponent,
    MaxMinPiecesComponent,
    AdvisorClientCreditComponent,
    PaymentTimeComponent,
    NewResponsibleDoctorComponent,
    AcceptNewPricesComponent,
    WarningPromotionalCodeComponent,
    WProductsNoValidPromoCodeComponent,
    ContinueBackMessageComponent,
    ConfirmDoctorNameDialogComponent,
    ChangeInvoiceTypeDialogComponent
  ],
  imports: [
    CommonModule,
    MatSelectModule,
    ComponentsModule,
    MatDialogModule,
    SignaturePadModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatIconModule,
    ReactiveFormsModule,
    InfiniteScrollModule,
    PipesModule,
    NgxMaskModule.forRoot(),
    RouterModule,
    MatFormFieldModule,
    FormsModule,
    MatDatepickerModule,
    MatCheckboxModule,
    NgxStarRatingModule,
    MatRadioModule,
    ClipboardModule,
    PdfViewerModule,
    DirectivesModule,
  ],
  exports: [SucessChangePaymentCardComponent,
    QuotationCommentsComponent,
    ProductsWithNamePrintedComponent,
    ConfirmRecipeComponent,
    ImageViewerComponent,
    ConfirmInvalidFavorBalanceComponent],
  entryComponents: [
    DetailOrderDialogComponent,
    SignatureDialogComponent,
    NewSpecialtyComponent,
    PreviewReceiptComponent,
    DoctorInformationDialogComponent,
    ChangePayMethodComponent,
    SuccessPayComponent,
    ServiceQualifierComponent,
  ],
})
export class DialogsModule { }
